import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup, Radio, HelpBlock, ButtonToolbar, ControlLabel, FormControl } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import MapModal from '../MapModal.jsx';
import CancelModal from '../CancelModal.jsx';

const dateFormat = 'D.M.YYYY';

class EventInfoForm extends Component {
  constructor(props) {
    super();

    this.state = {
      name: { status: null, error: '' },
      start_date: { status: null, error: '' },
      end_date: { status: null, error: '' },
      description: { status: null, error: '' },
      participant: { status: null, error: '' },
      eventLocation: { status: null, error: '' },
      scope: { status: null, error: '' },
      location: '',
      disableNextButton: false,
      showLocationSelect: false,
      showCancelConfirm: false,
      disableEndDate: true
    };
  }

  getDatePickerFormattedDate = (type) => {
    let date = moment(this.props.state.formData[type], dateFormat);
    if (!date.isValid()) {
      date = '';
    }
    return date;
  }

  handleChange = (e) => {
    this.props.handleChange(e.target.name, e.target.value);
    this.setState(this.props.displayError(e.target.name));
  }

  handleDateChange = (type, date) => {
    if (date === null) return;
    const formattedDate = moment(date).format(dateFormat);
    this.props.handleChange(type, formattedDate);
    this.setState(this.props.displayError('start_date'));
    this.setState(this.props.displayError('end_date'));
  }

  // This is for handling user input by typing.
  handleDateChangeRaw = (e, type) => {
    if (moment(e.target.value, dateFormat, true).isValid()) {
      const givenDate = (moment(e.target.value, dateFormat, true));
      const now = moment();
      (givenDate.isAfter(now)) ? this.handleDateChange(type, givenDate) : this.handleDateChange(type, now);
    } else {
      this.props.handleChange(type, e.target.value);
    }
  }

  checkIfShouldBeChecked = (value) => {
    if (this.props.state.formData.scope === value) {
      return true;
    }
    return false;
  }

  enableLocationSelect = () => {
    this.setState({ showLocationSelect: true });
  }

  disableLocationSelect = (e) => {
    this.setState({ showLocationSelect: false });
    this.setState(this.props.displayError('eventLocation'));
  }

  checkValidationErrors = () => {
    const state = this.props.checkValidationErrors(this.state);
    Object.entries(state).forEach(
        ([key, value]) => this.setState({ [key]: value })
    );
  }

  render() {
    return (
      <Form>
        <FormGroup validationState={this.state.name.status}>
          <br />
          <ControlLabel>Harjoituksen nimi</ControlLabel>
          <FormControl
            placeholder="Esim. Barents Rescue 2015"
            name="name"
            type="text"
            value={this.props.state.formData.name || ''}
            onChange={this.handleChange}
          />
          <HelpBlock>{this.state.name.error}</HelpBlock>
        </FormGroup>

        <FormGroup
          validationState={
            (this.state.start_date.status === 'error' || this.state.end_date.status === 'error') ? 'error' : null
          }
        >
          <ControlLabel>Ajankohta</ControlLabel>
          <br />
          <DatePicker
            selected={this.getDatePickerFormattedDate('start_date')}
            value={this.props.state.formData.start_date}
            startDate={this.getDatePickerFormattedDate('start_date')}
            endDate={this.getDatePickerFormattedDate('end_date')}
            onChange={date => this.handleDateChange('start_date', date)}
            selectsStart
            disabledKeyboardNavigation
            minDate={moment()}
            maxDate={this.getDatePickerFormattedDate('end_date')}
            dateFormat={dateFormat}
            placeholderText={'Aloitusajankohta'}
            onChangeRaw={e =>
              this.handleDateChangeRaw(e, 'start_date')}
          />
          {' '}
          <DatePicker
            selected={this.getDatePickerFormattedDate('end_date')}
            value={this.props.state.formData.end_date}
            startDate={this.getDatePickerFormattedDate('start_date')}
            endDate={this.getDatePickerFormattedDate('end_date')}
            onChange={date => this.handleDateChange('end_date', date)}
            selectsEnd
            disabledKeyboardNavigation
            minDate={(this.getDatePickerFormattedDate('start_date') === '')
              ? moment() : this.getDatePickerFormattedDate('start_date')}
            dateFormat={dateFormat}
            placeholderText={'Lopetusajankohta'}
            onChangeRaw={e =>
              this.handleDateChangeRaw(e, 'end_date')}
          />
          <HelpBlock>{this.state.start_date.error || this.state.end_date.error}</HelpBlock>
        </FormGroup>

        <FormGroup validationState={this.state.description.status}>
          <ControlLabel>Harjoituksen kuvaus</ControlLabel>
          <FormControl
            value={this.props.state.formData.description || ''}
            name="description"
            placeholder="Kuvaa harjoitusta, sen laajuutta ja tavoitteita lyhyesti"
            type="textarea"
            onChange={this.handleChange}
          />
          <HelpBlock>{this.state.description.error}</HelpBlock>
        </FormGroup>

        <FormGroup validationState={this.state.participant.status}>
          <ControlLabel>Osallistujat</ControlLabel>
          <FormControl
            value={this.props.state.formData.participant || ''}
            name="participant"
            placeholder="Esim. Lapin pelastuslaitos, Sisäministeriön pelastuslaitos, Suomen Punainen Risti"
            type="textarea"
            onChange={this.handleChange}
          />
          <HelpBlock>{this.state.participant.error}</HelpBlock>
        </FormGroup>

        <FormGroup validationState={this.state.eventLocation.status}>
          <ControlLabel>Sijainti</ControlLabel>
          <FormControl
            readOnly
            ref={(modal) => { this.modal = modal; }}
            onClick={this.enableLocationSelect}
            placeholder="Klikkaa tästä"
            name="eventLocation"
            value={
              (this.props.state.formData.lon === undefined)
                ? '' : `${this.props.state.formData.lon}, ${this.props.state.formData.lat}`
             }
            type="text"
          />
          <HelpBlock>{this.state.eventLocation.error}</HelpBlock>
        </FormGroup>

        <FormGroup validationState={this.state.scope.status}>
          <ControlLabel>Laajuus</ControlLabel>
          <Radio
            onChange={this.handleChange}
            checked={this.checkIfShouldBeChecked('8')}
            value="8"
            name="scope"
          >
            Kansainvälinen
          </Radio>
          <Radio
            onChange={this.handleChange}
            checked={this.checkIfShouldBeChecked('4')}
            value="4"
            name="scope"
          >Valtakunnallinen
          </Radio>
          <Radio
            onChange={this.handleChange}
            checked={this.checkIfShouldBeChecked('2')}
            value="2"
            name="scope"
          >Alueellinen
          </Radio>
          <Radio
            onChange={this.handleChange}
            checked={this.checkIfShouldBeChecked('1')}
            value="1"
            name="scope"
          >Paikallinen
          </Radio>
          <HelpBlock>{this.state.scope.error}</HelpBlock>
        </FormGroup>

        <ButtonToolbar>
          <br />
          <Button bsStyle="primary" disabled>Edellinen</Button>
          <Button bsStyle="primary" disabled={this.state.disableNextButton} onClick={this.checkValidationErrors}>Seuraava
          </Button>
          {' '}
          <Button onClick={() => this.setState({ showCancelConfirm: true })} >Keskeytä</Button>

          <CancelModal
            show={this.state.showCancelConfirm}
            handleCancel={this.props.handleCancel}
            disableCancelConfirm={() => this.setState({ showCancelConfirm: false })}
          />
        </ButtonToolbar>

        <MapModal
          ref={(modal) => { this.modal = modal; }}
          show={this.state.showLocationSelect}
          handleChange={this.props.handleChange}
          updateForm={this.props.updateForm}
          formData={this.props.state.formData}
          location={this.state.location}
          onIframeLoaded={this.onIframeLoaded}
          disableLocationSelect={this.disableLocationSelect}
        />
      </Form>
    );
  }
}

EventInfoForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  displayError: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired,
  checkValidationErrors: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  handleCancel: PropTypes.func.isRequired
};

export default EventInfoForm;



// WEBPACK FOOTER //
// ./src/components/forms/EventInfoForm.jsx